import { useState, useCallback } from 'react';

export const useWidgetsOverlay = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openOverlay = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeOverlay = useCallback(() => {
    setIsOpen(false);
  }, []);

  const toggleOverlay = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, []);

  return {
    isOpen,
    openOverlay,
    closeOverlay,
    toggleOverlay,
  };
};
